import type { Vector2 } from 'three';

export const inputPointerPosition = { x: 0, y: 0, altKey: false };

export function updateInputPointerPosition(event: Pick<PointerEvent, 'clientX' | 'clientY' | 'altKey'>): void {
    inputPointerPosition.x = event.clientX;
    inputPointerPosition.y = event.clientY;
    inputPointerPosition.altKey = event.altKey;
}

export function getCanvasPointer(
    canvas: HTMLCanvasElement,
    target: Vector2,
    position: { x: number; y: number } = inputPointerPosition
): boolean {
    const rect = canvas.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) {
        return false;
    }

    // Both client coordinates and the canvas bounds use CSS pixels, independent of DPR.
    target.set(((position.x - rect.left) / rect.width) * 2 - 1, 1 - ((position.y - rect.top) / rect.height) * 2);
    return true;
}
